import IFindAllMotoristasRequest from '../entities/IFindAllMotoristasRequest'
import IFindAllMotoristasResponse from '../entities/IFindAllMotoristasResponse'
import { IMotoristaRepository } from '../repositories/IMotoristaRepository'

export interface IFindByCpfNomeFrotistaId {
  execute(
    params: IFindAllMotoristasRequest,
  ): Promise<IFindAllMotoristasResponse>
}

export default class FindByCpfNomeFrotistaIdImpl
  implements IFindByCpfNomeFrotistaId
{
  constructor(private readonly motoristaRepository: IMotoristaRepository) {}
  async execute(
    params: IFindAllMotoristasRequest,
  ): Promise<IFindAllMotoristasResponse> {
    const response = await this.motoristaRepository.findByCpfNomeFrotistaId(
      params,
    )
    return response
  }
}
